import React from 'react';
import '../Assets/Donation.css';
import qrCodeImage from '../Assets/qr-code.png'; // Replace with your QR image
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

function Donation() {
  const { t } = useTranslation();
  const transactionId = new Date().getTime().toString(); // Unique ID
  const upiurl = "upi://pay?pa=abipp@indianbk&pn=ABIPP&cu=INR&tid="+transactionId
  
  return (
    <div className="donation-container tricolor-background">
      <h1>{t('donate.subtitle_1')}</h1>
      <p><Trans i18nKey='donate.p1.l1' /></p>
      <p className='text-left'><Trans i18nKey='donate.p1.l2' /></p>

      <div className="donation-section">
        <h2><Trans i18nKey='donate.subtitle_2' /></h2>
        <ul>
          <Trans i18nKey='donate.p2.ul1' />
        </ul>
      </div>

      <div className="donation-section">
        <h2><Trans i18nKey='donate.subtitle_3' /></h2>
        <img src={qrCodeImage} alt="Donate QR Code" className="qr-code" />
        <p className='upiid'>
          <Trans i18nKey='donate.p3.l1' />
        </p>
      </div>

      <div className="donation-section">
        <h2><Trans i18nKey='donate.subtitle_4' /></h2>
        <a href={upiurl} className="upi-button">
          <Trans i18nKey='donate.btn_text' />
        </a>
        <p><Trans i18nKey='donate.btn_info' /></p>
      </div>
    </div>
  );
}

export default Donation;
